// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d9a35230","455":"d5fa16a9"}[chunkId] + ".chunk.js";
};